import React, { FC, useEffect, useMemo } from 'react'
import { Button, Drawer, DrawerCloseButton, DrawerContent, DrawerOverlay, useDisclosure } from '@chakra-ui/react'

import useGetUnifiedPersonByID from 'components/tools/CustomForm/components/Viewer/hooks/useGetUnifiedPersonByID'
import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import UnifiedPersonCard from 'CitizenProfile/components/CitizenCard'
import SearchUnifiedPersonOnCustomForm from './components/SearchUnifiedPersonOnCustomForm'
import SelectUnifiedPersonOnCustomForm from './components/SelectUnifiedPersonOnCustomForm'
import { useCustomFormUnifiedPersonSelectionDrawerManager } from './contexts/CustomFormUnifiedPersonSelectionDrawerManager/Provider'

type Views = {
  [key: string]: JSX.Element
}

type Props = {
  question: CustomFormQuestion
  disabled?: boolean
}

const CustomFormUnifiedPersonSelectionDrawerContent: FC<Props> = ({ question, disabled }) => {
  const { isOpen, onClose, onOpen } = useDisclosure()

  const { getUnifiedPerson, loadingUnifiedPerson } = useGetUnifiedPersonByID()

  const { selectedUnifiedPerson, setSelectedUnifiedPerson, view, filter } =
    useCustomFormUnifiedPersonSelectionDrawerManager()

  const RenderComponent = useMemo(() => {
    const views: Views = {
      SEARCH_UNIFIED_PERSON: <SearchUnifiedPersonOnCustomForm onClose={onClose} />,
      SELECT_UNIFIED_PERSON: <SelectUnifiedPersonOnCustomForm onClose={onClose} />,
    }

    return views[view]
  }, [filter, view])

  async function loadUnifiedPerson(unifiedPersonId: string) {
    const unifiedPersonFromAPI = await getUnifiedPerson(unifiedPersonId)
    setSelectedUnifiedPerson(unifiedPersonFromAPI)
  }

  useEffect(() => {
    async function loadAsyncFunction() {
      if (question.default_value && question.default_value.length > 0) {
        const unifiedPersonId = question.default_value[0]
        await loadUnifiedPerson(unifiedPersonId)
      }
      if (question.answer && question.answer.length > 0) {
        const unifiedPersonId = question.answer[0]
        await loadUnifiedPerson(unifiedPersonId)
      }
    }
    loadAsyncFunction()
  }, [question])

  return (
    <>
      <Button
        isLoading={loadingUnifiedPerson}
        minWidth="100%"
        variant="outline"
        isDisabled={disabled}
        width="max-content"
        onClick={onOpen}
      >
        {selectedUnifiedPerson?.id ? 'Atualizar pessoa unificada' : 'Adicionar pessoa unificada'}
      </Button>

      {selectedUnifiedPerson?.id && (
        <UnifiedPersonCard
          isDefaultCitizenCard
          citizen={selectedUnifiedPerson}
          borderWidth="1px"
          borderColor="borderColor"
        />
      )}

      <Drawer isOpen={isOpen} onClose={onClose}>
        <DrawerOverlay />

        <DrawerContent>
          <DrawerCloseButton />

          {RenderComponent}
        </DrawerContent>
      </Drawer>
    </>
  )
}

export default CustomFormUnifiedPersonSelectionDrawerContent
